import { client, gql } from 'data-provider';

export const getDashboardCounts = async () => {
    const query = gql`
    query {
        findCounts {
            supplier
            warehouse
            product
            user
            purchase
            sales
        }
    }
  `;

    const data = await client.request(query);
    return data.findCounts;
};
